'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
* css classes mapping
* */
exports.default = {
  menu: 'react-contexify',
  submenu: 'react-contexify react-contexify__submenu',
  submenuArrow: 'react-contexify__submenu-arrow',
  separator: 'react-contexify__separator',
  item: 'react-contexify__item',
  itemDisabled: 'react-contexify__item--disabled',
  itemContent: 'react-contexify__item__data',
  itemIcon: 'react-contexify__item__icon',
  theme: 'react-contexify__theme--',
  animationWillEnter: 'react-contexify__will-enter--',
  animationWillLeave: 'react-contexify__will-leave--'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-contexify/lib/components/styles.js
// module id = 3apM
// module chunks = 7